<!--<template>
  <div class="acc-container" :style="{backgroundImage: `url(${require('../../assets/gcla/accreditation.png')})`}">
    <div class="acc-details text-center">
      <div class="sub-title white-color mb-2">Accreditation</div>
      <div class="bg-title white-color text-uppercase mb-3" v-html="'Become  An Accredited<br /> Training Center'">Accreditation</div>
      <router-link to="/" class="acc-btn">Explore</router-link>
    </div>
    <div class="gradient-easing"></div>
  </div>
</template>-->
<template>
  <div class="acc-container" :style="{backgroundImage: `url(${row.image3}) !important`}">
    <div class="acc-details text-center">
      <div class="sub-title mb-2" v-html="row.title3"></div>
      <div class="bg-title mb-3" v-html="row.body3"></div>
      <router-link v-if="row.redirect3" :to="row.redirect3" class="acc-btn" v-html="row.button3"></router-link>
    </div>
    <div class="gradient-easing"></div>
  </div>
</template>

<style scoped>
.acc-container {
  height: 500px;
  background-size: cover;
  position: relative;
  background-position: center top;
}
.acc-details {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 60px 30px;
  z-index: 10;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.acc-btn {
  background-color: #AF8916;
  color: #fff;
  font-size: 18px;
  padding: 6px 19px;
  line-height: 1;
  display: inline-block;
}
.acc-btn:hover {
  background: #9d7b13;
}
.acc-btn:active {
  opacity: 0.6;
}
.gradient-easing {
  height: 480px !important;
  position: absolute;
  width: 100%;
  background-image: linear-gradient(transparent,rgba(0,0,0,.00709) 10.47%,rgba(0,0,0,.02755) 19.56%,rgba(0,0,0,.06016) 27.58%,rgba(0,0,0,.1037) 34.81%,rgba(0,0,0,.15697) 41.57%,rgba(0,0,0,.21875) 48.13%,rgba(0,0,0,.28782) 54.79%,rgba(0,0,0,.36296) 61.85%,rgba(0,0,0,.44297) 69.61%,rgba(0,0,0,.52662) 78.36%,rgba(0,0,0,.6127) 88.39%,rgba(0,0,0,.7));
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  
}

@media (max-width: 767.98px) {
  .bg-title {
    font-size: 33px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
